import React from 'react';
import logo from '../assets/logo.svg';

const Footer = () => {
  const year = new Date();
  return (
    <footer id='contact' className='w-100 flex jcc aic bg-light'>
      <div className='container'>
        <div className='px-5 mx-3'>
          <div className='s-64'></div>
          <div className='row'>
            <div
              className='col-lg-4'
              style={{ transform: 'translateY(-20px)' }}
            >
              <a href='/' aria-label='Logotype'>
                <img src={logo} width={128} height={48} alt='c4u' />
              </a>
            </div>
            <div className='col-lg-8 tr'>
              <a href='/privacy-policy' className='title-mini'>
                Datenschutzrichtlinie
              </a>
              <a href='/terms-of-use' className='title-mini px-4'>
                Nutzungsbedingungen
              </a>
              <a href='/cookie-policy' className='title-mini'>
                Cookie-Richtlinie
              </a>
            </div>
          </div>
          <div className='s-32'></div>
          <div className='s-1 bg-grey'></div>
          <div className='s-40'></div>
          <div className='tc'>
            <span className='title-mini'>
              <a href='/'>C4U</a> @ {year.getFullYear()} - Alle Rechte vorbehalten.
            </span>
          </div>
          <div className='s-40'></div>
        </div>
      </div>
    </footer>
  );
};

export { Footer };